import * as React from "react";
import "../styles/chat.css";

const AssistantAvatar = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2L2 7l10 5 10-5-10-5z" />
    <path d="M2 17l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
);

const UserAvatar = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

interface MessageBubbleProps {
  role: "user" | "assistant";
  text: string;
  timestamp: string;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ role, text, timestamp }) => (
  <div className={`message ${role}`}>
    <div className="message-avatar">{role === "assistant" ? <AssistantAvatar /> : <UserAvatar />}</div>
    <div className="message-content">
      <div className="message-bubble">{text}</div>
      <div className="message-time">{timestamp}</div>
    </div>
  </div>
);

export default MessageBubble;
